<template>
  <div>
    <Header />
    <Article />
    <StatusInfo :key="statusRefreshKey" />
  </div>
</template>
<script>
import Header from '@/components/common/layout/Header.vue'
import Article from '@/components/common/layout/Article.vue'
import StatusInfo from '@/components/status/StatusInfo.vue'
import { mapState } from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    Header,
    Article,
    StatusInfo,
  },
  computed: {
    ...mapState('status', ['statusRefreshKey']),
  },
}
</script>
